import { type SupportedLocale } from "../i18n-locales";
import { type RouteKey } from "./routes";
import { absoluteUrl } from "./seo";

const KEYWORDS: Record<SupportedLocale, Record<RouteKey, readonly string[]>> = {
  it: {
    home: [
      "Enkey Agency",
      "web agency italiana",
      "siti web",
      "web app",
      "e-commerce",
      "marketing digitale",
      "SEO",
    ],
    about: [
      "chi siamo",
      "Enkey Agency",
      "web agency dal 1999",
      "Nicola Cossu",
      "agenzia digitale Carbonia",
    ],
    careers: [
      "lavora con noi",
      "offerte lavoro Carbonia",
      "Enkey Agency candidature",
      "tecnico informatico Carbonia",
      "consulente telefonia energia",
    ],
    services: [
      "servizi web",
      "sviluppo web",
      "web app",
      "e-commerce",
      "plugin WordPress",
      "moduli PrestaShop",
      "marketing digitale",
      "stampa digitale professionale",
    ],
    editorial: [
      "piano editoriale",
      "articoli SEO",
      "copywriting per aziende",
      "gestione contenuti sito",
      "calendario editoriale",
    ],
    sponsored: [
      "articoli sponsorizzati",
      "link building",
      "pubblicazione articoli",
      "digital PR",
      "network editoriale",
    ],
    portfolio: [
      "portfolio web agency",
      "siti WordPress",
      "e-commerce PrestaShop",
      "progetti custom",
      "web app",
    ],
    partners: [
      "partner Enkey",
      "connettività",
      "telefonia",
      "energia",
      "partner locali",
      "soluzioni digitali",
    ],
    blog: [
      "Enkey Magazine",
      "tecnologia",
      "design",
      "cultura digitale",
      "marketing",
      "lifestyle",
    ],
    shop: [
      "Enkey Store",
      "negozi online",
      "e-commerce",
      "elettronica",
      "informatica",
      "shop clienti",
    ],
    contact: [
      "supporto Enkey",
      "assistenza web",
      "ticket assistenza",
      "forum supporto",
    ],
    faq: ["FAQ Enkey", "domande frequenti", "assistenza digitale"],
    inquiries: [
      "contatti web agency",
      "richiesta preventivo",
      "preventivo sito web",
      "Enkey Carbonia",
    ],
    tools: [
      "strumenti digitali gratuiti",
      "configuratore PC",
      "preventivo sito web",
      "audit sito web",
      "calcolatori rete e backup",
      "Enkey Agency",
    ],
    privacy: [
      "privacy policy",
      "protezione dati",
      "GDPR",
      "trattamento dati personali",
      "Enkey Agency",
    ],
    cookie: [
      "cookie policy",
      "consenso cookie",
      "preferenze privacy",
      "cookie sito web",
      "Enkey Agency",
    ],
    terms: ["termini e condizioni", "servizi Enkey", "contratti online"],
    withdrawal: ["recesso online", "diritto di recesso", "reso 14 giorni"],
    search: [],
  },
  en: {
    home: [
      "Enkey Agency",
      "Italian web agency",
      "websites",
      "web apps",
      "e-commerce",
      "digital marketing",
      "SEO",
    ],
    about: [
      "about Enkey Agency",
      "web agency since 1999",
      "Nicola Cossu",
      "Italian digital agency",
      "web development team",
    ],
    careers: [
      "Enkey Agency careers",
      "jobs in Carbonia",
      "technology jobs Sardinia",
      "IT technician role",
      "digital agency vacancies",
    ],
    services: [
      "web services",
      "web development",
      "web apps",
      "e-commerce",
      "WordPress plugins",
      "PrestaShop modules",
      "digital marketing",
      "professional digital printing",
    ],
    editorial: [
      "editorial plan",
      "SEO articles",
      "business copywriting",
      "website content management",
      "editorial calendar",
    ],
    sponsored: [
      "sponsored articles",
      "link building",
      "article publishing",
      "digital PR",
      "editorial network",
    ],
    portfolio: [
      "web agency portfolio",
      "WordPress websites",
      "PrestaShop e-commerce",
      "custom projects",
      "web apps",
    ],
    partners: [
      "Enkey partners",
      "connectivity",
      "telecommunications",
      "energy",
      "local partners",
      "digital solutions",
    ],
    blog: [
      "Enkey Magazine",
      "technology",
      "design",
      "digital culture",
      "marketing",
      "lifestyle",
    ],
    shop: [
      "Enkey Store",
      "online shops",
      "e-commerce",
      "electronics",
      "IT products",
      "client shops",
    ],
    contact: [
      "Enkey support",
      "website support",
      "support tickets",
      "support forum",
    ],
    faq: ["Enkey FAQ", "frequently asked questions", "digital support"],
    inquiries: [
      "web agency contact",
      "request a quote",
      "website quote",
      "Enkey Carbonia",
    ],
    tools: [
      "free digital tools",
      "PC configurator",
      "website cost estimator",
      "website audit",
      "network and backup calculators",
      "Enkey Agency",
    ],
    privacy: [
      "privacy policy",
      "data protection",
      "GDPR",
      "personal data processing",
      "Enkey Agency",
    ],
    cookie: [
      "cookie policy",
      "cookie consent",
      "privacy preferences",
      "website cookies",
      "Enkey Agency",
    ],
    terms: ["terms and conditions", "Enkey services", "online contracts"],
    withdrawal: ["online withdrawal", "right of withdrawal", "14 day return"],
    search: [],
  },
  es: {
    home: [
      "Enkey Agency",
      "agencia web italiana",
      "sitios web",
      "apps web",
      "e-commerce",
      "marketing digital",
      "SEO",
    ],
    about: [
      "sobre Enkey Agency",
      "agencia web desde 1999",
      "Nicola Cossu",
      "agencia digital italiana",
      "equipo desarrollo web",
    ],
    careers: [
      "trabaja con nosotros",
      "empleo Carbonia",
      "vacantes Enkey Agency",
      "técnico informático",
      "agencia digital empleo",
    ],
    services: [
      "servicios web",
      "desarrollo web",
      "apps web",
      "e-commerce",
      "plugins WordPress",
      "módulos PrestaShop",
      "marketing digital",
      "impresión digital profesional",
    ],
    editorial: [
      "plan editorial",
      "artículos SEO",
      "copywriting para empresas",
      "gestión de contenidos web",
      "calendario editorial",
    ],
    sponsored: [
      "artículos patrocinados",
      "link building",
      "publicación de artículos",
      "relaciones públicas digitales",
      "red editorial",
    ],
    portfolio: [
      "portafolio agencia web",
      "sitios WordPress",
      "e-commerce PrestaShop",
      "proyectos a medida",
      "apps web",
    ],
    partners: [
      "socios Enkey",
      "conectividad",
      "telefonía",
      "energía",
      "socios locales",
      "soluciones digitales",
    ],
    blog: [
      "Enkey Magazine",
      "tecnología",
      "diseño",
      "cultura digital",
      "marketing",
      "estilo de vida",
    ],
    shop: [
      "Enkey Store",
      "tiendas online",
      "e-commerce",
      "electrónica",
      "informática",
      "tiendas de clientes",
    ],
    contact: [
      "soporte Enkey",
      "asistencia web",
      "tickets de soporte",
      "foro de soporte",
    ],
    faq: ["FAQ Enkey", "preguntas frecuentes", "asistencia digital"],
    inquiries: [
      "contacto agencia web",
      "solicitar presupuesto",
      "presupuesto sitio web",
      "Enkey Carbonia",
    ],
    tools: [
      "herramientas digitales gratuitas",
      "configurador PC",
      "estimador sitio web",
      "auditoría web",
      "calculadoras de red y copias",
      "Enkey Agency",
    ],
    privacy: [
      "política de privacidad",
      "protección de datos",
      "RGPD",
      "tratamiento de datos personales",
      "Enkey Agency",
    ],
    cookie: [
      "política de cookies",
      "consentimiento de cookies",
      "preferencias de privacidad",
      "cookies del sitio",
      "Enkey Agency",
    ],
    terms: ["términos y condiciones", "servicios Enkey", "contratos en línea"],
    withdrawal: ["desistimiento en línea", "derecho de desistimiento", "devolución 14 días"],
    search: [],
  },
  fr: {
    home: [
      "Enkey Agency",
      "agence web italienne",
      "sites web",
      "applications web",
      "e-commerce",
      "marketing digital",
      "SEO",
    ],
    about: [
      "à propos Enkey Agency",
      "agence web depuis 1999",
      "Nicola Cossu",
      "agence numérique italienne",
      "équipe développement web",
    ],
    careers: [
      "carrières Enkey Agency",
      "emploi Carbonia",
      "postes agence numérique",
      "technicien informatique",
      "candidature Enkey",
    ],
    services: [
      "services web",
      "développement web",
      "applications web",
      "e-commerce",
      "plugins WordPress",
      "modules PrestaShop",
      "marketing digital",
      "impression numérique professionnelle",
    ],
    editorial: [
      "plan éditorial",
      "articles SEO",
      "copywriting entreprise",
      "gestion de contenus web",
      "calendrier éditorial",
    ],
    sponsored: [
      "articles sponsorisés",
      "link building",
      "publication d’articles",
      "relations presse digitales",
      "réseau éditorial",
    ],
    portfolio: [
      "portfolio agence web",
      "sites WordPress",
      "e-commerce PrestaShop",
      "projets sur mesure",
      "applications web",
    ],
    partners: [
      "partenaires Enkey",
      "connectivité",
      "télécommunications",
      "énergie",
      "partenaires locaux",
      "solutions digitales",
    ],
    blog: [
      "Enkey Magazine",
      "technologie",
      "design",
      "culture digitale",
      "marketing",
      "lifestyle",
    ],
    shop: [
      "Enkey Store",
      "boutiques en ligne",
      "e-commerce",
      "électronique",
      "informatique",
      "boutiques clients",
    ],
    contact: [
      "support Enkey",
      "assistance web",
      "tickets d’assistance",
      "forum d’assistance",
    ],
    faq: ["FAQ Enkey", "questions fréquentes", "assistance numérique"],
    inquiries: [
      "contact agence web",
      "demande de devis",
      "devis site web",
      "Enkey Carbonia",
    ],
    tools: [
      "outils numériques gratuits",
      "configurateur PC",
      "estimateur site web",
      "audit de site",
      "calculateurs réseau et sauvegarde",
      "Enkey Agency",
    ],
    privacy: [
      "politique de confidentialité",
      "protection des données",
      "RGPD",
      "traitement des données personnelles",
      "Enkey Agency",
    ],
    cookie: [
      "politique de cookies",
      "consentement cookies",
      "préférences de confidentialité",
      "cookies du site",
      "Enkey Agency",
    ],
    terms: ["conditions générales", "services Enkey", "contrats en ligne"],
    withdrawal: ["rétractation en ligne", "droit de rétractation", "retour 14 jours"],
    search: [],
  },
  de: {
    home: [
      "Enkey Agency",
      "italienische Webagentur",
      "Websites",
      "Web-Apps",
      "E-Commerce",
      "digitales Marketing",
      "SEO",
    ],
    about: [
      "über Enkey Agency",
      "Webagentur seit 1999",
      "Nicola Cossu",
      "italienische Digitalagentur",
      "Webentwicklung Team",
    ],
    careers: [
      "Enkey Agency Karriere",
      "Jobs Carbonia",
      "Digitalagentur Stellen",
      "IT-Techniker Stelle",
      "Bewerbung Enkey",
    ],
    services: [
      "Webdienstleistungen",
      "Webentwicklung",
      "Web-Apps",
      "E-Commerce",
      "WordPress-Plugins",
      "PrestaShop-Module",
      "digitales Marketing",
      "professioneller Digitaldruck",
    ],
    editorial: [
      "Redaktionsplan",
      "SEO-Artikel",
      "Copywriting für Unternehmen",
      "Website-Inhaltsverwaltung",
      "Redaktionskalender",
    ],
    sponsored: [
      "gesponserte Artikel",
      "Linkbuilding",
      "Artikelveröffentlichung",
      "digitale PR",
      "redaktionelles Netzwerk",
    ],
    portfolio: [
      "Webagentur Portfolio",
      "WordPress-Websites",
      "PrestaShop E-Commerce",
      "individuelle Projekte",
      "Web-Apps",
    ],
    partners: [
      "Enkey Partner",
      "Konnektivität",
      "Telekommunikation",
      "Energie",
      "lokale Partner",
      "digitale Lösungen",
    ],
    blog: [
      "Enkey Magazine",
      "Technologie",
      "Design",
      "digitale Kultur",
      "Marketing",
      "Lifestyle",
    ],
    shop: [
      "Enkey Store",
      "Onlineshops",
      "E-Commerce",
      "Elektronik",
      "IT-Produkte",
      "Kundenshops",
    ],
    contact: [
      "Enkey Support",
      "Website-Support",
      "Support-Tickets",
      "Support-Forum",
    ],
    faq: ["Enkey FAQ", "häufige Fragen", "digitaler Support"],
    inquiries: [
      "Webagentur Kontakt",
      "Angebot anfordern",
      "Website-Angebot",
      "Enkey Carbonia",
    ],
    tools: [
      "kostenlose digitale Werkzeuge",
      "PC-Konfigurator",
      "Website-Kostenrechner",
      "Website-Audit",
      "Netzwerk- und Backup-Rechner",
      "Enkey Agency",
    ],
    privacy: [
      "Datenschutzerklärung",
      "Datenschutz",
      "DSGVO",
      "Verarbeitung personenbezogener Daten",
      "Enkey Agency",
    ],
    cookie: [
      "Cookie-Richtlinie",
      "Cookie-Einwilligung",
      "Datenschutzeinstellungen",
      "Website-Cookies",
      "Enkey Agency",
    ],
    terms: ["allgemeine Bedingungen", "Enkey Dienstleistungen", "Online-Verträge"],
    withdrawal: ["Online-Widerruf", "Widerrufsrecht", "14 Tage Rückgabe"],
    search: [],
  },
};

export function staticSeoKeywords(
  routeKey: RouteKey,
  locale: SupportedLocale,
): string[] {
  return [...KEYWORDS[locale][routeKey]];
}

export function staticSocialImagePath(routeKey: RouteKey): string {
  if (routeKey === "home") return "/social/home.png?v=0eaea55852ed8fdf";
  if (routeKey === "faq" || routeKey === "inquiries") {
    return "/social/contact.png";
  }
  return `/social/${routeKey}.png`;
}

export function staticSocialImage(routeKey: RouteKey): string {
  return absoluteUrl(staticSocialImagePath(routeKey));
}
